export default {"src":"/_next/static/media/ico_plus.eaea4c8f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};